import React from 'react'

// import components
import TopBar from '../components/TopBar'
import Header from '../components/account/Header'
import Footer from '../components/Footer'

const PrivacyPolicy = () => {
    return (
        <>
            <TopBar />
            
            <section className='section-terms-conditions'>
                <div className="container">
                    <div className="row">
                        <div className="col col-12 col-md-8 offset-md-2">
                            <Header headerTitle='Privacy Policy' />

                                <p><strong>boostedresume.com</strong> (the "Site") is owned and operated by <strong>Boosted Resume</strong>. Boosted Resume can be contacted at:</p>

                                <p>Email: <a href="mailto:info@boostedresume.com">info@boostedresume.com</a></p>

                                <h4>Purpose</h4>
                                <p>The purpose of this privacy policy (this "Privacy Policy") is to inform users of our Site of the following:</p>
                                <ol>
                                    <li>The personal data we will collect;</li>
                                    <li>Use of collected data;</li>
                                    <li>Who has access to the data collected; and</li>
                                    <li>The rights of Site users.</li>
                                </ol>
                                <p>This Privacy Policy applies in addition to the terms and conditions of our Site.</p>

                                <h4>Consent</h4>
                                <p>By using our Site users agree that they consent to:</p>
                                <ol>
                                    <li>The conditions set out in this Privacy Policy; and</li>
                                    <li>The collection, use, and retention of the data listed in this Privacy Policy.</li>
                                </ol>

                                <h4>Personal Data We Collect</h4>
                                <p>We only collect data that helps us achieve the purpose set out in this Privacy Policy. We will not collect any additional data beyond the data listed below without notifying you first.</p>

                                <h3>Data Collected Automatically</h3>
                                <p>When you visit and use our Site, we may automatically collect and store the following information:</p>
                                <ul>
                                    <li>IP address;</li>
                                    <li>Location;</li>
                                    <li>Hardware and software details;</li>
                                    <li>Clicked links; and</li>
                                    <li>Content viewed.</li>
                                </ul>

                                <h3>Data Collected in a Non-Automatic Way</h3>
                                <p>We may also collect the following data when you perform certain functions on our Site:</p>
                                <ul>
                                    <li>First and last name;</li>
                                    <li>Age;</li>
                                    <li>Date of birth;</li>
                                    <li>Sex;</li>
                                    <li>Email address;</li>
                                    <li>Phone number; and</li>
                                    <li>Address.</li>
                                </ul>
                                <p>This data may be collected using the following methods:</p>
                                <ul>
                                    <li>Account Completion.</li>
                                </ul>

                                <h4>How We Use Personal Data</h4>
                                <p>Data collected on our Site will only be used for the purposes specified in this Privacy Policy or indicated on the relevant pages of our Site. We will not use your data beyond what we disclose in this Privacy Policy.</p>

                                <p>The data we collect automatically is used for the following purposes:</p>
                                <ul>
                                    <li>Statistics.</li>
                                </ul>

                                <p>The data we collect when the user performs certain functions may be used for the following purposes:</p>
                                <ul>
                                    <li>Communication;</li>
                                    <li>Statistics; and</li>
                                    <li>Content Generation.</li>
                                </ul>

                                <h4>Who We Share Personal Data With</h4>
                                <p><strong>Employees</strong></p>
                                <p>We may disclose user data to any member of our organization who reasonably needs access to user data to achieve the purposes set out in this Privacy Policy.</p>

                                <p><strong>Other Disclosures</strong></p>
                                <p>We will not sell or share your data with other third parties, except in the following cases:</p>
                                <ul>
                                    <li>If the law requires it;</li>
                                    <li>If it is required for any legal proceeding;</li>
                                    <li>To prove or protect our legal rights; and</li>
                                    <li>To buyers or potential buyers of this company in the event that we seek to sell the company.</li>
                                </ul>

                                <p>If you follow hyperlinks from our Site to another Site, please note that we are not responsible for and have no control over their privacy policies and practices.</p>

                                <h4>How Long We Store Personal Data</h4>
                                <p>User data will be stored until the purpose the data was collected for has been achieved.</p>

                                <p>You will be notified if your data is kept for longer than this period.</p>

                                <h4>How We Protect Your Personal Data</h4>
                                <p>In order to protect your security, we use the strongest available browser encryption and store all of our data on servers in secure facilities. All data is only accessible to our employees. Our employees are bound by strict confidentiality agreements and a breach of this agreement would result in the employee's termination.</p>

                                <p>While we take all reasonable precautions to ensure that user data is secure and that users are protected, there always remains the risk of harm. The Internet as a whole can be insecure at times and therefore we are unable to guarantee the security of user data beyond what is reasonably practical.</p>

                                <h4>Children</h4>
                                <p>We do not knowingly collect or use personal data from children under 13 years of age. If we learn that we have collected personal data from a child under 13 years of age, the personal data will be deleted as soon as possible. If a child under 13 years of age has provided us with personal data, their parent or guardian may contact our privacy officer.</p>

                                <h4>How to Access, Modify, Delete, or Challenge the Data Collected</h4>
                                <p>If you would like to know if we have collected your personal data, how we have used your personal data, if we have disclosed your personal data and to whom we disclosed your personal data, or if you would like your data to be deleted or modified in any way, please contact our privacy officer here:</p>

                                <p>Ryan Cadby</p>
                                <p>Email: <a href="mailto:info@boostedresume.com">info@boostedresume.com</a></p>

                                <h4>Do Not Track Notice</h4>
                                <p>Do Not Track ("DNT") is a privacy preference that you can set in certain web browsers. We do not track the users of our Site over time and across third party websites and therefore do not respond to browser-initiated DNT signals.</p>

                                <h4>How to Opt-Out of Data Collection, Use or Disclosure</h4>
                                <p>In addition to the method(s) described in the How to Access, Modify, Delete, or Challenge the Data Collected section, we provide the following specific opt-out methods for the forms of collection, use, or disclosure of your personal data specified below:</p>

                                <p>You can opt-out of the use of your personal data for marketing emails. You can opt-out by emailing our support team at <a href="mailto:info@boostedresume.com">info@boostedresume.com</a>.</p>

                                <h4>Modifications</h4>
                                <p>This Privacy Policy may be amended from time to time in order to maintain compliance with the law and to reflect any changes to our data collection process. When we amend this Privacy Policy, we will update the "Effective Date" at the top of this Privacy Policy. We recommend that our users periodically review our Privacy Policy to ensure that they are notified of any updates. If necessary, we may notify users by email of changes to this Privacy Policy.</p>

                                <h4>Contact Information</h4>
                                <p>If you have any questions, concerns, or complaints, you can contact our privacy officer, Ryan Cadby, at:</p>

                                <p>Email: <a href="mailto:info@boostedresume.com">info@boostedresume.com</a></p>

                        </div>
                    </div>
                </div>
                
            </section>
            <Footer />
        </>
        
    )
}

export default PrivacyPolicy